// extracted by mini-css-extract-plugin
export var arrow = "FlashCard-module--arrow--557a3";
export var bar = "FlashCard-module--bar--b6464";
export var card = "FlashCard-module--card--5a30a";
export var imageContainer = "FlashCard-module--image-container--338da";
export var title = "FlashCard-module--title--8a8ac";